import React from 'react';

interface PillProps {
    children: React.ReactNode;
    active?: boolean;
    onClick?: () => void;
}

const Pill: React.FC<PillProps> = ({ children, active = false, onClick }) => {
    return (
        <button
            type="button"
            className={`st-pill ${active ? 'active' : ''}`}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default Pill;